module.exports = __webpack_public_path__ + "static/worldepilepsy-ef20055811bdffc89e0a981fa3833097.png";